import {flow, types, getRoot} from "mobx-state-tree";
import * as pdfjsLib from 'pdfjs-dist';
import {ViewFilePicState} from "../../../../components/mediaFiles/view/ViewFilePicState";
import {MediaFile} from "../../../../models/mediaFiles/MediaFileModel";
import {MediaFileSelectState} from "../../../elements/mediaFiles/MediaFileSelectState";

const LogoState = types.model('LogoState', {
  logoPercentageWidth: types.optional(types.integer, 27),
  selectedFromAssets: types.optional(types.string, ''),
  logo: types.optional(types.string, ''),
  logoType:types.optional(types.string, ''),
  logoMargin: types.optional(types.integer, 1),
  logoMarginWarn: types.optional(types.boolean, false),
  logoFormat: types.optional(types.string, ''),
  pdfLogoPng: types.optional(types.string, ''),
  logoOffsetX: types.optional(types.integer, 0),
  logoOffsetXWarn: types.optional(types.boolean, false),
  logoOffsetY: types.optional(types.integer, 0),
  logoOffsetYWarn: types.optional(types.boolean, false),
  cropAroundImage: types.optional(types.boolean, false),
  backgroundImage: types.optional(types.string, ''),
  backgroundImageFormat: types.optional(types.string, ''),
  fullBackground: types.optional(types.boolean, false),
  logoFileIsCorrectSize: types.optional(types.boolean, true),
  logoFileIsCorrectType: types.optional(types.boolean, true),
  logoSizeWarn: types.optional(types.boolean, false),
  activeTab:types.optional(types.string, '1'),
  openBackgroundImage: types.optional(types.boolean, false),

  logoMediaFileSelectState: types.maybeNull(MediaFileSelectState),
  backgroundMediaFileSelectState: types.maybeNull(MediaFileSelectState),
  logoMediaFile: types.maybe(MediaFile),
  backgroundMediaFile: types.maybe(MediaFile),
  // mediaFileUUID: types.optional(types.string, ""),
  // mediaFiles: types.optional(types.frozen(),""),
  // fileForS3Upload: types.optional(types.frozen(),{}),
  // viewFilePicState: types.maybeNull(ViewFilePicState),
  // singleUseFile: types.optional(types.boolean, true),
})
  .volatile(self => ({
    notifyDesigner: types.f,
    notifyDesignerDeleteKey:types.f,
    notifyPreview:types.f,
    notifyUploadLogo:types.f,
    notifyCharacteristics:types.f,
  }))
  .actions((self) => ({
    setConsumer(f) {
      self.notifyDesigner = f
    },
    setOnSelectChanges() {
      // IMPORTANT: Keep this empty to avoid overwriting the consumer set in DesignerTemplateUtil.js
      // The consumer in DesignerTemplateUtil calls handleMediaFileSelection which handles all logic
    },
    setDeleteKeyConsumer(f){
      self.notifyDesignerDeleteKey = f
    },
    setPreviewConsumer(f){
      self.notifyPreview = f
    },
    setUploadLogoConsumer(f){
      self.notifyUploadLogo = f
    },
    setNotifyCharacteristics(f){
      self.notifyCharacteristics = f
    },
    /**
     * Updates logo properties and syncs with designer state
     * Preserves user-set values and only updates when changed
     * @param {string} base64 - Base64 encoded logo image
     */
    sideEffectMobXUpdateImage(base64) {
      self.logo = base64
      self.notifyDesigner("logo", base64)
      // Sync MST properties with extendConfig
      self.notifyDesigner("logoPercentageWidth",self.logoPercentageWidth)
      self.notifyDesigner("logoMargin",self.logoMargin)

      // if(self.logoPercentageWidth === 33){
      //   self.notifyDesigner("errorCorrection","H")
      //   self.notifyCharacteristics("errorCorrection","H")
      // }else{
      //   self.notifyDesigner("errorCorrection","Q")
      //   self.notifyCharacteristics("errorCorrection","Q")
      // }
    },

    toggleBackgroundImage(base64){
      self.backgroundImage = base64
      self.notifyDesigner("backgroundImage", base64)
    },
    async setSelectedImage(file, isLogo, eyesAndModulesStore) {
      const fileIsCorrectSize = file?.size < 2000000
      let fileType = file?.type.split("/")[1].toUpperCase()
      const fileIsCorrectType = (
        fileType === "PNG" ||
        fileType === "BMP" ||
        fileType === "TIF" || fileType === "TIFF" ||
        fileType === "JPEG"||
        fileType === "PDF"||
        fileType === "EPS"||
        fileType === "POSTSCRIPT")
      if (fileIsCorrectSize && fileIsCorrectType) {
        self.logoFileIsCorrectSize = fileIsCorrectSize
        self.logoFileIsCorrectType = fileIsCorrectType
        self.logoFormat = file?.type
        if(fileType === "JPEG") {
          fileType = "JPG"
          self.logoFormat = fileType
        }

        // *******************    since we are using mediaFile service, we don't need to below  *******************
        // let reader = new FileReader()
        // let pdfLogoPng = ""
        // reader.onload = async function (event) {
        //   if(isLogo){
        //     self.sideEffectMobXUpdateImage(reader.result.split("base64,")[1])
        //     let errorCorrection;

        //     if (self.logoPercentageWidth > 25) {
        //       errorCorrection = "H";
        //     } else if (self.logoPercentageWidth >= 15) {
        //       errorCorrection = "Q";
        //     } else {
        //       errorCorrection = "M";
        //     }

        //     self.notifyDesigner("errorCorrection", errorCorrection);
        //     self.notifyCharacteristics("errorCorrection", errorCorrection);

        //   }else{
        //     self.toggleBackgroundImage(reader.result.split("base64,")[1])
        //     eyesAndModulesStore.handleShapeChange("dataShape", 2, self)
        //   }
        //   if(fileType === "PDF"){
        //     const base64Pdf = reader.result.split("base64,")[1];
        //     pdfLogoPng = await self.convertBase64PdfToPng(base64Pdf)
        //     self.setPdfLogoPng(pdfLogoPng)
        //   }

        // }.bind(this)

        // if (file) {
        //   reader.readAsDataURL(file);
        // }

        // self.notifyPreview()
        // *******************    since we are using mediaFile service, we don't need to above  *******************
        if(isLogo){
          let errorCorrection;

          if (self.logoPercentageWidth > 25) {
            errorCorrection = "H";
          } else if (self.logoPercentageWidth >= 15) {
            errorCorrection = "Q";
          } else {
            errorCorrection = "M";
          }

          self.notifyDesigner("errorCorrection", errorCorrection);
          self.notifyCharacteristics("errorCorrection", errorCorrection);

        }else{
          eyesAndModulesStore.handleShapeChange("dataShape", 2, self)
        }
        return true
      }else{
        // !fileIsCorrectSize && new Notification()
        //   .setType("error")
        //   .setMessage(`File size: ${file?.size / 1000} MB \n File can not exceed 3MB`)
        //   .send();
        // !fileIsCorrectType && new Notification()
        //   .setType("error")
        //   .setMessage(`File type: ${fileType} is not accepted \n Accepted formats: PNG, JPEG, BMP, GIF, TIF, SVG, PDF, EPS`)
        //   .send();
        self.logoFileIsCorrectSize = fileIsCorrectSize
        self.logoFileIsCorrectType = fileIsCorrectType
        return false
      }
    },
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          resolve(event.target.result);
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsDataURL(file);
      });
    },
    setPdfLogoPng(pngBase64){
      self.pdfLogoPng = pngBase64
      self.notifyDesigner("pdfLogoPng",pngBase64)
    },
    /**
     * Updates logo size using MST action and syncs with designer state
     * @param {Event} e - Input change event
     */
    handleLogoSize(e) {
      const newSize = +e.currentTarget.value;
      self.setLogoPercentageWidth(newSize);
      self.notifyDesigner("logoPercentageWidth", newSize);

      if(newSize > 33) {
        self.logoSizeWarn = true
      }else{
        self.logoSizeWarn = false
      }
      if(newSize > 25 && self.logo !== ""){
        self.notifyDesigner("errorCorrection","H")
        self.notifyCharacteristics("errorCorrection","H")
      }else if(newSize >= 15 && newSize <= 25 && self.logo !== ""){
        self.notifyDesigner("errorCorrection","Q")
        self.notifyCharacteristics("errorCorrection","Q")
      } else if(newSize < 15 && self.logo !== ""){
        self.notifyDesigner("errorCorrection","M")
        self.notifyCharacteristics("errorCorrection","M")
      }
    },
    /**
     * Updates logo margin using MST action and syncs with designer state  
     * @param {Event} e - Input change event
     */
    handleLogoMargin(e){
      if(e.currentTarget.value === ""){
        return
      }
      const value = parseInt(e.currentTarget.value)
      if(value >= -1 && value <= 3){
        self.setLogoMargin(value);
        self.logoMarginWarn = false
        self.notifyDesigner("logoMargin", self.logoMargin)
      } else {
        self.setLogoMargin(value);
        self.logoMarginWarn = true
        // Notify designer even for invalid values to maintain state sync
        self.notifyDesigner("logoMargin", self.logoMargin)
      }
    },
    /**
     * MST action to update logo percentage width
     * @param {number} value - New logo percentage width value
     */
    setLogoPercentageWidth(value) {
      self.logoPercentageWidth = value;
    },
    /**
     * MST action to update logo margin
     * @param {number} value - New logo margin value
     */
    setLogoMargin(value) {
      self.logoMargin = value;
    },
    handleSelectedFromAssets(e) {
      self.selectedFromAssets = e.target.value
    },
    removeLogo(){
      self.notifyDesignerDeleteKey("logo")
      self.logo = ''
      // Clear liveLinks so toggles disappear
      self.logoMediaFile.setLiveLinks({});
      self.notifyPreview()
      self.notifyDesigner("errorCorrection","M")
      self.notifyCharacteristics("errorCorrection","M")
      self.notifyDesignerDeleteKey("pdfLogoPng")
    },
    async convertBase64PdfToPng(base64Pdf) {
      var pdfData = atob(base64Pdf);
      // Asynchronous download of PDF
      if(pdfData === "") return
      var loadingTask = pdfjsLib.getDocument({data: pdfData});
      let pngBase64 = ""
      var pdf = await loadingTask.promise

      // Fetch the first page
      var pageNumber = 1;
      var page = await pdf.getPage(pageNumber);

      var scale = 1;
      var viewport = page.getViewport({scale: scale});

      // Prepare canvas using PDF page dimensions
      const canvas = document.createElement('canvas');
      document.body.appendChild(canvas)
      var context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      // Render PDF page into canvas context
      var renderContext = {
        canvasContext: context,
        viewport: viewport
      };
      var renderTask = page.render(renderContext);
      await renderTask.promise
      pngBase64 = canvas.toDataURL();
      return pngBase64


    },
    handleLogoOffsetX(e){
      const value = parseInt(e.currentTarget.value)
      if(value >= -15 && value <= 15){
        self.logoOffsetX = value
        self.notifyDesigner("logoOffsetX",self.logoOffsetX)
        self.logoOffsetXWarn = false
      } else {
        self.logoOffsetX = value
        self.logoOffsetXWarn = true
        // new Notification()
        //   .setType("error")
        //   .setMessage(`Right range is from -15 to 15`)
        //   .send();
      }
    },
    handleLogoOffsetY(e){
      const value = parseInt(e.currentTarget.value)
      if(value >= -15 && value <= 15){
        self.logoOffsetY = +e.currentTarget.value
        self.notifyDesigner("logoOffsetY",(self.logoOffsetY))
        self.logoOffsetYWarn = false
      } else {
        self.logoOffsetY = value
        self.logoOffsetYWarn = true
        // new Notification()
        //   .setType("error")
        //   .setMessage(`Down range is from -15 to 15`)
        //   .send();
      }
    },
    toggleCropAroundImage(){
      self.cropAroundImage = !self.cropAroundImage
      if(self.cropAroundImage){
        self.notifyDesigner("stripLogoBackground", 1)
      }else{
        self.notifyDesignerDeleteKey("stripLogoBackground")
        // self.notifyDesigner("stripLogoBackground", 0)
      }
    },
    removeBackgroundImage(){
      self.notifyDesignerDeleteKey("backgroundImage")
      self.backgroundImage = ''
    },
    toggleFullBackground(){
      self.fullBackground = !self.fullBackground
      self.notifyDesigner("fullBackground", self.fullBackground)
    },
    toggleEmptyLogoTab(){
      self.logoType = 'emptyImage'
      self.notifyDesigner("logoType", self.logoType)
      self.notifyDesigner("logoPercentageWidth",self.logoPercentageWidth)
      self.notifyDesigner("logoMargin",self.logoMargin)
      self.notifyPreview()
    },
    toggleLogoTab(){
      self.logoType = 'logoImage'
      self.notifyDesigner("logoType", self.logoType)
      self.notifyPreview()
    },
    toggleBackgroundImageTab(){
      self.logoType = 'backgroundImage'
      self.notifyDesigner("logoType", self.logoType)
      self.notifyPreview()
    },
    setOpenBackgroundImage(bool){
      self.openBackgroundImage = !self.openBackgroundImage
    },
    toggleTab(tab) {
        console.log('tab', tab)
          if(tab === '1') {
            self.activeTab = '1'
            self.toggleLogoTab()
          }  else if(tab === '2') {
            self.activeTab = '2'
            self.toggleEmptyLogoTab()
          }
    },
    handleLogoMediaFileSelect(selectedMediaFile) {
      if (selectedMediaFile && selectedMediaFile.liveLinks) {
        // Update the logoMediaFile with the selected media file data
        self.logoMediaFile.mediaFileUUID = selectedMediaFile.uuid;
        self.logoMediaFile.name = selectedMediaFile.name;
        self.logoMediaFile.fileFormat = selectedMediaFile.fileFormat;
        self.logoMediaFile.liveLinks = selectedMediaFile.liveLinks;

        // Trigger designer notifications for logo update
        if (selectedMediaFile.liveLinks.original) {
          const base64Data = selectedMediaFile.liveLinks.original.includes('base64,')
            ? selectedMediaFile.liveLinks.original.split('base64,')[1]
            : selectedMediaFile.liveLinks.original;
          self.sideEffectMobXUpdateImage(base64Data);
        }

        // Notify preview update
        self.notifyPreview();
      }
    },
    handleBackgroundMediaFileSelect(selectedMediaFile) {
      if (selectedMediaFile && selectedMediaFile.liveLinks) {
        // Update the backgroundMediaFile with the selected media file data
        self.backgroundMediaFile.mediaFileUUID = selectedMediaFile.uuid;
        self.backgroundMediaFile.name = selectedMediaFile.name;
        self.backgroundMediaFile.fileFormat = selectedMediaFile.fileFormat;
        self.backgroundMediaFile.liveLinks = selectedMediaFile.liveLinks;

        // Trigger designer notifications for background image update
        if (selectedMediaFile.liveLinks.original) {
          const base64Data = selectedMediaFile.liveLinks.original.includes('base64,')
            ? selectedMediaFile.liveLinks.original.split('base64,')[1]
            : selectedMediaFile.liveLinks.original;
          self.toggleBackgroundImage(base64Data);
        }

        // Notify preview update
        self.notifyPreview();
      }
    },
    handleFilePicState(image){
      self.viewFilePicState = ViewFilePicState.create({fileImageUrl: image})
    },
    removeLogoMediaFile() {
      // Call the existing removeMediaFile method on the logoMediaFile
      if (self.logoMediaFile) {
        self.logoMediaFile.removeMediaFile("root_mediaFileCode_logo");
      }

      // Clear the logo MediaFileSelectState selection
      if (self.logoMediaFileSelectState) {
        self.logoMediaFileSelectState.setSelectedToUndefined();
      }

      // Additional cleanup for logo-specific state
      self.logo = '';

      // Reset logo parameters to default values
      self.logoPercentageWidth = 27;
      self.logoOffsetX = 0;
      self.logoOffsetY = 0;
      self.logoMargin = 1;

      // Reset warning states
      self.logoSizeWarn = false;
      self.logoOffsetXWarn = false;
      self.logoOffsetYWarn = false;
      self.logoMarginWarn = false;

      // Delete logo-related keys from the config (not just reset to defaults)
      self.notifyDesignerDeleteKey("logo");
      self.notifyDesignerDeleteKey("pdfLogoPng");
      self.notifyDesignerDeleteKey("logoPercentageWidth");
      self.notifyDesignerDeleteKey("logoOffsetX");
      self.notifyDesignerDeleteKey("logoOffsetY");
      self.notifyDesignerDeleteKey("logoMargin");
      self.notifyDesigner("errorCorrection", "M");

      // Notify characteristics
      self.notifyCharacteristics("errorCorrection", "M");

      // Trigger preview update
      self.notifyPreview();
    },
    removeBackgroundMediaFile() {
      // Call the existing removeMediaFile method on the backgroundMediaFile
      if (self.backgroundMediaFile) {
        self.backgroundMediaFile.removeMediaFile("root_mediaFileCode_background");
      }

      // Clear the background MediaFileSelectState selection
      if (self.backgroundMediaFileSelectState) {
        self.backgroundMediaFileSelectState.setSelectedToUndefined();
      }

      // Additional cleanup for background-specific state
      self.backgroundImage = '';
      self.notifyDesignerDeleteKey("backgroundImage");
      self.notifyPreview();
    },
    /**
     * Smart consumer callback that routes selections based on field name
     */
    handleMediaFileSelection(selectedMediaFile, experienceFieldName) {
      if (experienceFieldName === 'mediaFileCode_logo') {
        self.handleLogoMediaFileSelect(selectedMediaFile);
      } else if (experienceFieldName === 'mediaFileCode_background') {
        self.handleBackgroundMediaFileSelect(selectedMediaFile);
      }
    },
    createMediaFile(uuid) {
      return MediaFile.create({
        uuid: uuid,
        singleUseFile: true,
        liveLinks: { original: '' },
      });
    },
    createMediaFileSelectState(uuid, name) {
      return MediaFileSelectState.create({
        selectStateUuid: uuid,
        name: name,
        selected: null,
      });
    },
    loadMediaFiles: flow(function* () {
      try {
        // Load media files for logo state
        if (self.logoMediaFileSelectState?.store) {
          yield self.logoMediaFileSelectState.store.getMediaFiles({
            "usage": "content",
            "status": "UPLOADED"
          });
        }

        // Load media files for background state (they share the same store)
        if (self.backgroundMediaFileSelectState?.store) {
          yield self.backgroundMediaFileSelectState.store.getMediaFiles({
            "usage": "content",
            "status": "UPLOADED"
          });
        }
      } catch (error) {
        console.warn('Failed to load media files for designer:', error);
      }
    }),
    afterCreate() {
      // LogoState is now initialized via DesignerTemplateUtil.initLogoStore()
      // which provides the proper mediaFileSelectState and MediaFile instances
      // This method is kept for compatibility but most initialization is handled externally
    },
  })).views(self => ({
    doesLogoExist(){
      // Check for both thumbnail OR original since liveLinks can have either
      const hasLogo = (self.logoMediaFile.liveLinks?.thumbnail && self.logoMediaFile.liveLinks.thumbnail !== "") ||
                      (self.logoMediaFile.liveLinks?.original && self.logoMediaFile.liveLinks.original !== "");
      return hasLogo;
    },
    getCurrentLogoThumbnail(){
      // Return thumbnail if available, otherwise return original
      return self.logoMediaFile.liveLinks?.thumbnail ||
             self.logoMediaFile.liveLinks?.original ||
             "";
    }
  }))

export default LogoState;
//
// const [logoSize , setLogoSize] = useState(3)
// const [logo, setSelectedImage] = useState(null);